import { ReactNode } from 'react';
import { Button, Dialog } from '../';

interface ConfirmProps {
    title: string;
    children?: ReactNode;
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    closeText?: string;
    confirmText?: string;
    closeTestId?: string;
    confirmTestId?: string;
}

export const Confirm = ({ open, onClose, title, children, onConfirm, closeText, confirmText, closeTestId, confirmTestId }: ConfirmProps) => {
    return (
        <Dialog open={open} onClose={onClose} title={title}>
            <div className="pb-5">{children}</div>
            <div className="flex justify-end gap-x-4">
                <Button data-testid={closeTestId} variant="warning" onClick={() => onClose()}>
                    {closeText ? closeText : 'No'}
                </Button>
                <Button
                    data-testid={confirmTestId}
                    variant="success"
                    onClick={() => {
                        onClose();
                        onConfirm();
                    }}
                >
                    {confirmText ? confirmText : 'Yes'}
                </Button>
            </div>
        </Dialog>
    );
};
